import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../Store";
import {selectPour} from "../redux/Pour";
import {selectCart} from "../redux/Cart";
import Loader from "../components/Loader";

const Cart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {id} = useParams();
    const data = useSelector((state: RootState) => state);

    const clickMe =
        (parameter: {id: null ,position: null; name: ""; price: 0; qty: 0; unit: "" }) => () => {
            console.log(parameter)
            dispatch(selectPour(parameter));
            navigate("/cart/" + id + "/pour/" + parameter.position);
        };

    useEffect(() => {

        if (data.cart.list.length > 0) {

            let detail = data.cart.list.find(
                (cartList: { id: any, code: string }) => cartList.code == id
            );

            dispatch(selectCart(detail));

        }

    });

    return (
        <>
            <div className="flex flex-col p-6">
                <h4 className="text-2xl mb-6 font-semibold text-gray-900 ">Products</h4>
                <div className="grid grid-cols-2 grid-rows-3 gap-4">
                    {data.pour.list.length > 0 &&
                        data.cart.detail.id &&
                        data.pour.list.map((pour: any, index: number) => {
                            if (data.cart.detail.id === pour.cart_id) {
                                return (
                                    <button
                                        className="flex flex-col items-center bg-gray-100 rounded-xl p-4"
                                        onClick={clickMe(pour)}
                                        key={index}
                                    >
                                        <div>
                                            {pour.beverageDetail.logo ? (
                                                <img
                                                    src={pour.beverageDetail.logo}
                                                    alt={pour.beverageDetail.name}
                                                    style={{width: "150px", height: "150px"}}
                                                    className="rounded-full"
                                                />
                                            ) : (
                                                // <div style={{ width: '150px', height: '150px', backgroundColor: 'gray', borderRadius: '100' }}>
                                                //   Image Not Available
                                                // </div>
                                                <img
                                                    width="150"
                                                    src={""}
                                                    className="rounded-full"
                                                />
                                            )}
                                            <div className="leading-none">
                                                <h2 className="text-gray-800 text-lg font-semibold mt-2">
                                                    #{pour.position} {pour.beverageDetail.name}
                                                </h2>
                                                <h3 className="text-lg">
                                                    ${pour.price}/{pour.beverageDetail.unitName}
                                                </h3>
                                            </div>
                                            {/* <h4>{pour.unit} fl oz</h4> */}
                                        </div>
                                    </button>
                                );
                            }
                        })}

                    {data.pour.list.length == 0 && (
                        <div className={"w-full"}>
                            <Loader/>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Cart;
